(() => {
  const initialize = (container) => {
    container.querySelectorAll('[data-suedlis-klassisch]').forEach((root) => {
      if (root.dataset.klassischReady) return;
      const select = root.querySelector('[data-suedlis-variant-select]');
      const choices = root.querySelector('[data-sl-choices]');
      const buttons = [...root.querySelectorAll('[data-sl-variant]')];
      if (!select || !choices || !buttons.length) return;
      const selected = root.querySelector('[data-sl-selected]');
      const caption = root.querySelector('[data-sl-image-caption]');
      const sync = () => {
        buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.slVariant === select.value)));
        if (selected) selected.textContent = select.selectedOptions[0]?.textContent || '';
        const activeThumb = root.querySelector('[data-suedlis-gallery-thumb][aria-pressed="true"]');
        if (caption && activeThumb) caption.textContent = activeThumb.dataset.imageCaption || '';
      };
      buttons.forEach((button) => button.addEventListener('click', () => {
        select.value = button.dataset.slVariant;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      select.addEventListener('change', sync);
      root.querySelectorAll('[data-suedlis-gallery-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
        if (caption) caption.textContent = thumb.dataset.imageCaption || '';
      }));
      root.dataset.klassischReady = 'true';
      root.classList.add('has-variant-choices');
      choices.hidden = false;
      sync();
    });
  };
  initialize(document);
})();
